import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "./AuthShell";
import { GoogleButton } from "./GoogleButton";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { errMsg } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/dashboard", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(identifier, password);
      toast.success("Welcome back!");
      navigate("/dashboard");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Welcome back"
      subtitle="Log in to your Pack Mate account."
      footer={<>New here? <Link to="/signup" className="text-primary font-semibold" data-testid="link-signup">Create an account</Link></>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div className="space-y-1.5">
          <Label>Email or phone</Label>
          <Input data-testid="login-identifier-input" value={identifier} onChange={(e) => setIdentifier(e.target.value)} placeholder="you@example.com" className="rounded-xl h-11" required />
        </div>
        <div className="space-y-1.5">
          <div className="flex items-center justify-between">
            <Label>Password</Label>
            <Link to="/forgot-password" className="text-xs text-primary font-medium" data-testid="link-forgot">Forgot password?</Link>
          </div>
          <PasswordInput data-testid="login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="rounded-xl h-11" required />
        </div>
        <Button type="submit" disabled={loading} data-testid="login-submit-button" className="w-full rounded-xl h-11">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Log in"}
        </Button>
      </form>
      <div className="mt-5"><GoogleButton /></div>
    </AuthShell>
  );
}
